<template>
  <div>
    <h5 class="text-center info-text">Complete la información del seguimiento de Produccioón</h5>

    <div class="row justify-content-center mt-5">
      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label"> Fecha de Cosecha </label>

          <el-date-picker
            v-model="formData.harvestDate"
            v-validate="modelValidations.harvestDate"
            align="center"
            :editable="false"
            format="dd-MM-yyyy"
            name="harvestDate"
            placeholder="Fecha de Cosecha"
            suffix-icon="fas fa-calendar-alt"
            type="date"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>

          <small v-if="formData.harvestDate"> Días de cosecha: {{ daysToHarvest }} </small>

          <small v-show="harvestDate.invalid" class="text-danger">
            {{ getError('harvestDate') }}
          </small>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="form-group">
          <label class="control-label"> Fecha de Picado </label>

          <el-date-picker
            v-model="formData.chopDate"
            v-validate="modelValidations.chopDate"
            align="center"
            :editable="false"
            format="dd-MM-yyyy"
            name="chopDate"
            placeholder="Fecha de Cosecha"
            suffix-icon="fas fa-calendar-alt"
            type="date"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>

          <small v-if="formData.chopDate"> Días de picado: {{ daysToChop }} </small>

          <small v-show="chopDate.invalid" class="text-danger">
            {{ getError('chopDate') }}
          </small>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-sm-3">
        <label class="mt-3"> Altura de plantas <small>[m]</small> </label>

        <el-input
          v-model="formData.plantHeight"
          v-validate="modelValidations.plantHeight"
          class="mb-4"
          name="plantHeight"
          placeholder="Altura de plantas"
        >
        </el-input>

        <small v-show="plantHeight.invalid" class="text-danger">
          {{ getError('plantHeight') }}
        </small>
      </div>

      <div class="col-sm-3">
        <label class="mt-3"> Inserción de Espiga <small>[m]</small> </label>

        <el-input
          v-model="formData.spikeInsertion"
          v-validate="modelValidations.spikeInsertion"
          class="mb-4"
          name="spikeInsertion"
          placeholder="Inserción de Espiga"
        >
        </el-input>

        <small v-show="spikeInsertion.invalid" class="text-danger">
          {{ getError('spikeInsertion') }}
        </small>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-sm-6">
        <el-checkbox
          v-model="formData.hasInoculation"
          border
          class="form-control"
          label="¿Inocula?"
          name="hasInoculation"
        >
        </el-checkbox>
      </div>
    </div>
    <div class="row justify-content-center mb-4">
      <div class="col-sm-6">
        <el-input
          v-if="formData.hasInoculation"
          v-model="formData.inoculantBrand"
          v-validate="modelValidations.inoculantBrand"
          name="inoculantBrand"
          placeholder="Marca Inoculante"
        >
        </el-input>

        <small v-show="inoculantBrand.invalid" class="text-danger">
          {{ getError('inoculantBrand') }}
        </small>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-sm-6">
        <label class="mt-3"> Marca Maq. Picadora </label>

        <el-input
          v-model="formData.chopperMachine"
          v-validate="modelValidations.chopperMachine"
          class="mb-4"
          name="chopperMachine"
          placeholder="Marca Maq. Picadora"
        >
        </el-input>

        <small v-show="chopperMachine.invalid" class="text-danger">
          {{ getError('chopperMachine') }}
        </small>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-sm-6">
        <label> Rendimiento <span class="h5 text-muted">[Kg/HA]</span> </label>

        <el-input
          v-model="formData.storagePerformance"
          v-validate="modelValidations.storagePerformance"
          class="mb-4"
          name="storagePerformance"
          placeholder="Rendimiento Kg/HA"
        >
        </el-input>

        <small v-show="storagePerformance.invalid" class="text-danger">
          {{ getError('storagePerformance') }}
        </small>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-sm-6">
        <label> Rendimiento <span class="h5 text-muted">[MV/HA]</span> </label>

        <el-input
          v-model="formData.harvestPerformance"
          v-validate="modelValidations.harvestPerformance"
          class="mb-4"
          name="harvestPerformance"
          placeholder="Rendimiento MV/HA"
        >
        </el-input>

        <small v-show="harvestPerformance.invalid" class="text-danger">
          {{ getError('harvestPerformance') }}
        </small>
      </div>
    </div>

    <button class="btn btn-success btn-fill btn-wd btn-next float-right" @click="save">Guardar</button>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { Select, Option, DatePicker, Checkbox } from 'element-ui';

export default {
  components: {
    [Checkbox.name]: Checkbox,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
  },

  props: {
    plot: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formData: {
        chopDate: this.plot.harvest ? this.plot.harvest.chopDate : null,
        harvestDate: this.plot.harvest ? this.plot.harvest.harvestDate : null,
        chopperMachine: this.plot.harvest ? this.plot.harvest.chopperMachine : null,
        plantHeight: this.plot.harvest ? this.plot.harvest.plantHeight : null,
        spikeInsertion: this.plot.harvest ? this.plot.harvest.spikeInsertion : null,
        storagePerformance: this.plot.harvest ? this.plot.harvest.storagePerformance : null,
        harvestPerformance: this.plot.harvest ? this.plot.harvest.harvestPerformance : null,
        hasInoculation: this.plot.harvest ? Boolean(this.plot.harvest.hasInoculation) : false,
        inoculantBrand: this.plot.harvest ? this.plot.harvest.inoculant_brand : null,
        plotId: this.plot.id,
      },

      modelValidations: {
        plantHeight: {
          decimal: 2,
        },

        spikeInsertion: {
          decimal: 2,
        },
      },
    };
  },

  computed: {
    daysToHarvest() {
      if (this.plot.preEmergence) {
        return this.$diffDates({
          dateFrom: this.plot.preEmergence.seedDate,
          dateTo: this.formData.harvestDate,
        });
      }
      return null;
    },

    daysToChop() {
      if (this.plot.preEmergence) {
        return this.$diffDates({
          dateFrom: this.plot.preEmergence.seedDate,
          dateTo: this.formData.chopDate,
        });
      }
      return null;
    },

    ...mapFields([
      'harvestDate',
      'chopDate',
      'inoculantBrand',
      'chopperMachine',
      'storagePerformance',
      'harvestPerformance',
      'plantHeight',
      'spikeInsertion',
    ]),
  },

  methods: {
    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    async validate() {
      try {
        return await this.$validator.validateAll();
      } catch (e) {
        return new Promise((resolve, reject) => {
          reject(e);
        });
      } finally {
      }
    },

    save() {
      this.validate().then((res) => {
        if (res) {
          this.store();
        }
      });
    },

    async store() {
      this.formData.plotId = this.plot.id;
      const response = (await this.plot.harvest) ? this.update() : this.create();

      response.then((res) => res.data.data).then((data) => this.$emit('saved', data));
    },

    create() {
      return this.$services.resource('harvests').create(this.formData);
    },

    update() {
      return this.$services.resource('harvests').update(this.plot.harvest.id, this.formData);
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
